import { render } from "./CartRecap.vue?vue&type=template&id=0206e581"
import script from "./CartRecap.vue?vue&type=script&setup=true&lang=js"
export * from "./CartRecap.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/components/CartRecap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0206e581"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0206e581', __exports__)) {
    console.log('reload')
    api.reload('0206e581', __exports__)
  }
  
  module.hot.accept("./CartRecap.vue?vue&type=template&id=0206e581", () => {
    console.log('re-render')
    api.rerender('0206e581', render)
  })

}


export default __exports__